import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../../components/alert-dialog/alert-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private dialog: MatDialog) { }

  openDialog(title: string, message: string) {
    return this.dialog.open(AlertDialogComponent, {
      data: { title, message }
    });
  }
}
